import { render, staticRenderFns } from "./HealthData.vue?vue&type=template&id=05072944&"
import script from "./HealthData.vue?vue&type=script&lang=js&"
export * from "./HealthData.vue?vue&type=script&lang=js&"
import style0 from "./HealthData.vue?vue&type=style&index=0&id=05072944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports